<template>
    <canvas ref="canvas"></canvas>
</template>

<script>
import { Chart, ArcElement, DoughnutController, Tooltip, Legend } from 'chart.js';
Chart.register(ArcElement, DoughnutController, Tooltip, Legend);

export default {
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            chart: null
        };
    },

    mounted() {
        this.renderChart();
    },

    watch: {
        chartData: {
            deep: true,
            handler() {
                this.chart.data = this.chartData;
                this.chart.update();
            }
        }
    },

    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    },

    methods: {
        renderChart() {
            this.chart = new Chart(this.$refs.canvas, {
                type: 'doughnut',
                data: this.chartData,
                options: this.options
            });
        }
    }
};
</script>
